// eslint-disable-next-line import/prefer-default-export
export const FOLLOW_PROCESSING_END = 'FOLLOW_PROCESSING_END'
export const FOLLOW_PROCESSING_START = 'FOLLOW_PROCESSING_START'
export const UPDATE_API_PROFILE = 'UPDATE_API_PROFILE'
